/** Sort options for preorders search. */
const PREORDERS_SERVICE_SORT = {
    DATE_PURCHASED_ASC: 'datePurchasedAsc',
    DATE_PURCHASED_DESC: 'datePurchasedDesc',
    BUYER_ASC: 'buyerAsc',
    BUYER_DESC: 'buyerDesc',
    ORDER_FEE_ASC: 'orderFeeAsc',
    ORDER_FEE_DESC: 'orderFeeDesc',
};

export { PREORDERS_SERVICE_SORT };
//# sourceMappingURL=PreordersServiceSort.js.map
